<main class="mx-auto w-full max-w-5xl pb-12 text-strong">
    <button type="button" (click)="previousPage()"
            class="mb-5 inline-flex min-h-[40px] items-center gap-2 border-0 bg-transparent p-0 text-sm font-medium text-slate-600 hover:text-primary">
        <i class="bi bi-arrow-left" aria-hidden="true"></i> Torna al profilo atleta
    </button>

    <header class="mb-6">
        <h1 class="m-0 text-2xl font-bold tracking-tight text-strong sm:text-3xl">Dettaglio iscrizioni</h1>
        <p class="mb-0 mt-2 text-sm leading-6 text-slate-600">Tutte le richieste di iscrizione effettuate, con stato del pagamento e ricevute.</p>
    </header>

    <div *ngIf="loading" class="flex animate-pulse flex-col gap-3" role="status" aria-label="Caricamento iscrizioni">
        <div *ngFor="let skeleton of [1, 2, 3]" class="h-20 rounded-xl border border-slate-200 bg-white"></div>
    </div>

    <div *ngIf="!loading && !subscriptions.length"
         class="flex flex-col items-center rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-10 text-center">
        <i class="bi bi-receipt mb-2 text-3xl text-slate-400" aria-hidden="true"></i>
        <p class="m-0 font-semibold text-strong">Nessuna iscrizione</p>
        <p class="mb-0 mt-1 max-w-sm text-sm text-slate-600">Le iscrizioni dell'atleta compariranno qui dopo la prima richiesta.</p>
    </div>

    <ng-container *ngIf="!loading && subscriptions.length">
        <!-- Telefono: card -->
        <ul class="m-0 flex list-none flex-col gap-3 p-0 md:hidden">
            <li *ngFor="let row of subscriptions" class="rounded-xl border border-slate-200 bg-white p-4">
                <div class="flex items-start justify-between gap-3">
                    <div class="min-w-0">
                        <p class="m-0 font-semibold text-strong">{{ row.season.name || '—' }}</p>
                        <p class="m-0 text-sm text-slate-600">{{ row.category.name || '—' }}</p>
                    </div>
                    <span class="inline-flex shrink-0 items-center gap-1.5 rounded-md px-2 py-1 text-xs font-semibold" [ngClass]="status(row).classes">
                        <i class="bi" [ngClass]="status(row).icon" aria-hidden="true"></i>{{ status(row).label }}
                    </span>
                </div>
                <div class="mt-3 flex items-center justify-between gap-3 border-0 border-t border-solid border-slate-100 pt-3">
                    <span class="truncate text-xs text-slate-500">{{ row.athlete.firstName }} {{ row.athlete.lastName }}</span>
                    <a *ngIf="receiptUrl(row) as url; else noReceipt" [href]="url" target="_blank" rel="noopener"
                       class="btn btn-sm welldone-btn-light inline-flex min-h-[40px] shrink-0 items-center gap-1.5">
                        <i class="bi bi-download" aria-hidden="true"></i> Ricevuta
                    </a>
                </div>
            </li>
        </ul>

        <!-- Desktop: tabella -->
        <div class="hidden overflow-hidden rounded-xl border border-slate-200 bg-white md:block">
            <table class="w-full border-collapse text-left text-sm">
                <thead class="bg-slate-50 text-slate-600">
                    <tr>
                        <th scope="col" class="px-4 py-3 font-semibold">Stagione / Categoria</th>
                        <th scope="col" class="px-4 py-3 font-semibold">Atleta</th>
                        <th scope="col" class="px-4 py-3 font-semibold">Stato</th>
                        <th scope="col" class="px-4 py-3 text-right font-semibold">Ricevuta</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                    <tr *ngFor="let row of subscriptions">
                        <td class="px-4 py-4">
                            <span class="block font-semibold text-strong">{{ row.season.name || '—' }}</span>
                            <span class="block text-slate-600">{{ row.category.name || '—' }}</span>
                        </td>
                        <td class="px-4 py-4 text-strong">{{ row.athlete.firstName }} {{ row.athlete.lastName }}</td>
                        <td class="px-4 py-4">
                            <span class="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-semibold" [ngClass]="status(row).classes">
                                <i class="bi" [ngClass]="status(row).icon" aria-hidden="true"></i>{{ status(row).label }}
                            </span>
                        </td>
                        <td class="px-4 py-4 text-right">
                            <a *ngIf="receiptUrl(row) as url; else noReceipt" [href]="url" target="_blank" rel="noopener"
                               class="btn btn-sm welldone-btn-light inline-flex items-center gap-1.5">
                                <i class="bi bi-download" aria-hidden="true"></i> Scarica
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>
</main>

<ng-template #noReceipt><span class="text-xs text-slate-400">Non disponibile</span></ng-template>
